import { v4 as uuidv4 } from 'uuid';
export const currentISOTimeStamp = () => new Date().toISOString();
// UUID for eventId
export const newEventId = () => uuidv4();
